// 举报的对象;
export enum ReportObject {
  MODEL = 1, // 模型;
  COMMENT, // 评论;
  USER, // 用户;
}
